import type { ReactElement } from 'react';
import { api } from '../../../utils/api.ts';
import { SearchSelect } from './search-select.tsx';

export type ShippingTypeInputProps = {
    className?: string;
    disabled?: boolean;
    onChange?: (value: string) => void;
    placeholder?: string;
    value: string;
};

export function ShippingTypeInput({
    className,
    disabled,
    onChange,
    placeholder,
    value,
}: ShippingTypeInputProps): ReactElement {
    const { data: shippingTypeList, isLoading: isShippingTypeListLoading } =
        api.platoUser.query.salesDraft.getSalesDraftOptions.getShippingTypes.useQuery();

    return (
        <SearchSelect
            className={className}
            disabled={disabled}
            items={shippingTypeList}
            idSelector={(x) => x.id}
            isLoading={isShippingTypeListLoading}
            onSelectedIdChange={onChange}
            placeholder={placeholder}
            renderItem={(x) => `${x.id} ${x.name}`}
            selectedId={value}
            textSelector={(x) => `${x.id} ${x.name}`}
        />
    );
}
